<cms-news-card [descriptionLimit]="descriptionLimit" [news]="news" [titleLimit]="titleLimit"></cms-news-card>
